import * as React from 'react';
import SignatureCanvas from 'react-signature-canvas';
function BEM(props) {
    const { variant = 'dark', disabled, employee, isInvalid, className } = props;
    const classArray = ['signature', `signature--${variant}`];
    if (disabled) {
        classArray.push('signature--disabled');
    }
    if (employee) {
        classArray.push('signature--employee');
    }
    if (isInvalid) {
        classArray.push('signature--invalid');
    }
    if (className) {
        classArray.push(className);
    }
    return classArray.join(' ');
}
const SignatureCore = (props) => {
    const signatureRef = React.useRef(null);
    const { components, isFocusable = true, helper, label, clearButton, onClear, onEnd, onBegin, elementRef, disabled, children, employee, } = props;
    const { FormHelper, Grid, GridColumn, Button } = components;
    function getClearButton(btn) {
        return (React.createElement(GridColumn, { width: ['xs'] },
            React.createElement(Button, Object.assign({ size: "small", iconLeft: "#close", variant: "secondary", type: employee ? 'employee' : undefined, disabled: disabled }, btn, { onClick: onClear }))));
    }
    function getCanvas() {
        if (disabled) {
            return null;
        }
        return (React.createElement(SignatureCanvas, { canvasProps: {
                className: 'signature__canvas-inner',
            }, onBegin: onBegin, onEnd: onEnd, ref: elementRef }));
    }
    return (React.createElement("div", { className: BEM(props) },
        React.createElement(Grid, { align: ['between-xs', 'middle-xs'] },
            React.createElement(GridColumn, { width: ['xs'], className: "signature__label" },
                React.createElement("span", { className: disabled ? 'text-light' : undefined }, label)),
            clearButton && getClearButton(clearButton)),
        React.createElement("div", { className: "signature__canvas", ref: signatureRef, tabIndex: isFocusable ? 0 : undefined }, children ? children : getCanvas()),
        helper && React.createElement(FormHelper, Object.assign({ className: "signature__form-helper" }, helper))));
};
export default SignatureCore;
